import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import { PzCampaignStore } from 'stores';
import analyticsUtil from '../util/AnalyticsUtil';
import '../client/temp-common-imports';

export class PzSignUpController implements Controller {
  public pageId = 'SignUp';
  public path = '/:localeName/pz-signup';
  public routeName = 'pz-signup';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/pz-signup-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch = async (options: FetchOptions): Promise<Result> => {
    const { stores, request, query } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');
    const pzCampaignStore: PzCampaignStore = stores && stores.get<PzCampaignStore>('pzCampaignStore');

    const pageName = 'page.affhub.pzsignup';
    const context = request.context;

    analyticsUtil.runAnalytics(pageName, analyticsStore, context);

    // const programName = query.programName;
    // pzCampaignStore.fetchCampaign(programName, context.locale);

    return Promise.resolve(Result.ok());
  };

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Partnerize Signup' }) as Promise<PageData>;
  }
}
